import Color from 'color';
import React from 'react';
import MersenneTwister from 'mersenne-twister';
var WOBBLE = 30;
var BASE_COLORS = /*#__PURE__*/['#01888C', '#FC7500', '#034F5D', '#F73F01', '#FC1960', '#C7144C', '#F3C100', '#1598F2', '#2465E1', '#F19E02'].map(function (hex) {
  return Color(hex);
});

var Colors = /*#__PURE__*/function () {
  function Colors(generator, wobble) {
    if (wobble === void 0) {
      wobble = WOBBLE;
    }

    this.generator = generator;
    this.wobble = wobble; // Hue Shift

    var amount = generator.random() * 30 - this.wobble / 2;
    this.colors = BASE_COLORS.map(function (color) {
      color.rotate(amount);
      return color;
    });
  }

  var _proto = Colors.prototype;

  _proto.next = function next() {
    this.generator.random(); // Apparently, to maintain compatibility with original Jazzicon

    var idx = Math.floor(this.colors.length * this.generator.random());
    return this.colors.splice(idx, 1)[0];
  };

  return Colors;
}();

var BASE_STYLES = {
  borderRadius: '50%',
  overflow: 'hidden',
  padding: 0,
  margin: 0,
  width: '100%',
  height: '100%',
  display: 'inline-block'
};

function Paper(props) {
  var style = Object.assign({}, BASE_STYLES, {
    backgroundColor: props.color.hex()
  });
  return React.createElement("div", {
    className: props.className
  }, React.createElement("div", {
    style: style
  }, props.children));
}

var SVG_NS = 'http://www.w3.org/2000/svg';

function Shape(props) {
  var diameter = 100;
  var firstRot = props.generator.random();
  var angle = Math.PI * 2 * firstRot;
  var velocity = diameter / props.total * props.generator.random() + props.index * diameter / props.total;
  var tx = Math.cos(angle) * velocity;
  var ty = Math.sin(angle) * velocity;
  var translate = 'translate(' + tx.toFixed(3) + ' ' + ty.toFixed(3) + ')';
  var secondRot = props.generator.random();
  var rot = firstRot * 360 + secondRot * 180;
  var center = diameter / 2;
  var rotate = 'rotate(' + rot.toFixed(1) + ' ' + center + ' ' + center + ')';
  var transform = translate + ' ' + rotate;
  var fill = props.colors.next();
  return React.createElement("rect", {
    xmlns: SVG_NS,
    x: 0,
    y: 0,
    width: '100%',
    height: '100%',
    transform: transform,
    fill: fill.hex()
  });
}

var DEFAULT_SHAPE_COUNT = 3;

function times(n) {
  return Array.from({
    length: n
  }, function (_, i) {
    return i;
  });
}

function Jazzicon(props) {
  var seed = parseInt(props.address.toLowerCase().slice(2, 10), 16);
  var generator = new MersenneTwister(seed);
  var colors = new Colors(generator);
  var paperColor = colors.next();

  var renderShapes = function renderShapes() {
    return times(DEFAULT_SHAPE_COUNT).map(function (i) {
      return React.createElement(Shape, {
        generator: generator,
        total: DEFAULT_SHAPE_COUNT,
        index: i,
        key: "shape-" + i,
        colors: colors
      });
    });
  };

  return React.createElement(Paper, {
    color: paperColor,
    className: props.className
  }, React.createElement("svg", {
    x: 0,
    y: 0,
    xmlns: SVG_NS,
    viewBox: '0 0 100 100'
  }, renderShapes()));
}

export { BASE_STYLES, Colors, Jazzicon, Paper, Shape };